import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationJwtData } from './Data';

export interface IntegrationJwtState extends BaseIntegrationState {
  fieldsMapped: number[];
  parameterName?: string;
}

export class IntegrationJwtModel extends BaseIntegration<IntegrationJwtData, IntegrationJwtState> {
  parse(data: IntegrationJwtData) {
    super.parse(data);

    this.state.fieldsMapped = data.settings?.jwt_fields_mapped ?? [];
    this.state.parameterName = data.settings?.jwt_parameter_name;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/jwt/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
